import { render, staticRenderFns } from "./DeletedUsers.vue?vue&type=template&id=3cc45852&scoped=true&"
import script from "./DeletedUsers.vue?vue&type=script&lang=js&"
export * from "./DeletedUsers.vue?vue&type=script&lang=js&"
import style0 from "./DeletedUsers.vue?vue&type=style&index=0&id=3cc45852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc45852",
  null
  
)

export default component.exports